import { intl } from "LocaleWrapper";
import useLayout from "components/layout/useLayout";
import CharterSideviewer from "./CharterSideviewer";

const useOpenCharterSideviewer = () => {
	const layout = useLayout();

	return (charterId: number, refetch: () => void = () => undefined, declarationId?: number) => {
		layout.setDrawerSettings({
			open: true,
			title: intl.formatMessage({ id: "CHARTER" }),
			content: (
				<CharterSideviewer
					defaultCharterId={charterId}
					declarationId={declarationId}
					refetch={() => refetch()} />
			),
			size: "normal",
			variant: "inlay",
		});
	};
};

export default useOpenCharterSideviewer;
